import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import theme from 'theme/theme';
import { DeleteIcon } from 'assets/materialIcons/materialIcons';

const Container = styled.div`
    position: relative;
    flex: 0 1 10%;
    height: 60px;
`;

const Icon = styled(DeleteIcon)`
    display: block !important;
    height: 100% !important;
    opacity: 0.5;
    padding: 0;
    margin: 0 auto;

    &:hover {
        opacity: 1;
    }
`;

const CloseButton = (props) => {
    return (
        <Container>
            <Icon color={ theme.palette.primary1Color } hoverColor={ theme.palette.redOrange } onClick={ props.onClick } />
        </Container>
    );
};

CloseButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default CloseButton;



// WEBPACK FOOTER //
// ./src/components/tabs/tab/CloseButton.js